import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Header from "../../common/header";
import Amplify, { Auth,Hub } from 'aws-amplify';
import BounceLoader from 'react-spinners/BounceLoader'
import LoadingOverlay from '../../common/Loader';
import { axiosClient, config } from  '../../Services/Config';
// var apiConfig = require('../../Services/constant.json')[process.env.REACT_APP_ENV || 'dev'];

const { REACT_APP_ENV } = process.env;
var apiConfig = require('../../Services/constant.json')[REACT_APP_ENV.trim()];

import { withRouter } from "react-router-dom";



  
Auth.configure(apiConfig.cognito)


const loaderStyle = {
    color: '#f3f3f3',
    
  };
class login extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            email: '',
            password: '',
            switch1Value: false,
            user: '',
            spinnerLoading: false

        }
    }
    componentDidMount = () => {
        const userinfo = localStorage.getItem('userinfo');
        if (userinfo) {
            this.props.history.push('/home');
        }

        Hub.listen("auth", ({ payload: { event, data } }) => {
            // console.log(event,data);
            switch (event) {
              case "signIn":
                this.authorisation(data)
                // this.setState({ user: data });
                break;
              case "signOut":
                // this.setState({ user: null });
                break;
              case "customOAuthState":
                // this.setState({ customState: data });
            }
          });
    }

    handleEmail = (text) => {
        this.setState({ email: text })
    }
    handlePassword = (text) => {
        this.setState({ password: text })
    }

    authorisation = async (user) => {
        this.setState({ spinnerLoading: true });
        try {

            var _self = this;
            if (user && user.username && user.signInUserSession && user.signInUserSession.idToken && user.signInUserSession.idToken.jwtToken) {
                // console.log(user.signInUserSession.idToken.jwtToken)
                // console.log(user.signInUserSession);
                localStorage.setItem(
                    'token',
                    user.signInUserSession.idToken.jwtToken);
                let token = localStorage.getItem('token');

                var uname = user.username.replace('na-adfs_NA', '').replace('na-adfs_', '').replace('\\', '').replace('@la-z-boy.com', '');
                // axiosClient.post('https://s080lexhab.execute-api.us-east-1.amazonaws.com/v1/auth/getrole', new URLSearchParams({ username: user.username }), { headers: { "Authorization": `${token}` } })
                axiosClient.post(apiConfig.base_url + '/auth/getrole', new URLSearchParams({ username: uname }), { headers: { "Authorization": `${token}` } })
                    .then(result => {
                        if (result.data.status == 200) {
                            this.setState({ spinnerLoading: false });

                            if (result.data.data == undefined) {
                                alert('Authentication failed ')
                                return;
                            }
                            if (result.data.data && result.data.data.length == 0) {
                                alert('Authentication failed ')
                                return;
                            }
                            user.roleinfo = result.data.data;
                            if (user.roleinfo.tasks.indexOf("DCGViewAdminReports") != -1 || user.roleinfo.tasks.indexOf("DCGManageGlobalItems") != -1) {
                                localStorage.setItem(
                                    'userinfo',
                                    JSON.stringify(user));
                                if (user.roleinfo.tasks.indexOf("DCGManageGlobalItems") != -1) {
                                    _self.props.history.push('/daily-summary');

                                } else {
                                    _self.props.history.push('/daily-summary');
                                }
                                // console.log(user.roleinfo.tasks)
                            } else {
                                _self.props.history.push('/unauth');
                            }

                        } else {
                            this.setState({ spinnerLoading: false });
                            alert('Login Failed ')
                        }
                    })
                    .catch(err => {
                        this.setState({ spinnerLoading: false })
                        console.log(err);
                    })
            } else {
                this.setState({ spinnerLoading: false })
                console.log('not a valid ');
            }
        } catch (error) {
            this.setState({ spinnerLoading: false })
            console.log('error signing in', error);
            alert('Login Failed ! Username or Password is incorrect ')
        }
    }

    signIn = async (u, p) => {
        try {
            this.setState({ spinnerLoading: true });
            event.preventDefault();  
            const user = await Auth.signIn(u, p);
            console.log('user', user);
            var _self = this;
            if (user && user.username && user.signInUserSession && user.signInUserSession.idToken && user.signInUserSession.idToken.jwtToken) {
                // console.log(user.signInUserSession.idToken.jwtToken)
                // console.log(user.signInUserSession);
                localStorage.setItem(
                    'token',
                    user.signInUserSession.idToken.jwtToken);
                let token = localStorage.getItem('token');
                // console.log('token', token);

                var uname = user.username.replace('na-adfs_','').replace('@la-z-boy.com','');
                // axiosClient.post(apiConfig.base_url +'/auth/getrole', new URLSearchParams({ username: user.username }), { headers: { "token": `${token}` } })
                axiosClient.post(apiConfig.base_url +'/auth/getrole', new URLSearchParams({ username: uname }))
                
                    .then(result => {
                        if (result.data.status == 200) {
                            this.setState({ spinnerLoading: false });

                            user.roleinfo = result.data.data;
                            localStorage.setItem(
                                'userinfo',
                                JSON.stringify(user));
                                // _self.props.history.push('/dcg-questions');
                                if(user.roleinfo.roleid==16)
                                {
                                    _self.props.history.push('/daily-summary');
                                } else {
                                    _self.props.history.push('/unauth');
                                }

                        } else {
                            this.setState({ spinnerLoading: false });
                            alert('Login Failed ')
                        }
                        console.log('result');
                    })
                    .catch(err => {
                        this.setState({ spinnerLoading: false });
                        console.log(err);
                    })
            } else {
                this.setState({ spinnerLoading: false });
                console.log('not a valid User');
            }
        } catch (error) {
            this.setState({ spinnerLoading: false });
            console.log('error signing in', error);
            alert('Login Failed ')
        }
    }
    render() {

        return (

            <div className="wrapper">
                <LoadingOverlay active={this.state.spinnerLoading} spinner={<BounceLoader />} className={loaderStyle} >

                    <Header />
                    <div className="content-wrapper" id="ml_0">


                        <section className="content">
                            <div className="container">
                                <div className="login-box">
                                    <h4 className="pt-4 pb-3 pl-5 mb-0"><b>Sign into your account</b></h4>
                                    <hr className="m-0" />
                                    <div className="pt-4 pl-5 pr-5 pb-3 custom-forms">
                                        <div className="form-group text-center">
                                            <button className="btn btn-primary btn-block mt-4 mb-2"
                                                    onClick={() => Auth.federatedSignIn()}
                                                >Login with your LA-Z-BOY ACCOUNT</button>
                                        </div>
                                        </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </LoadingOverlay>


                <aside className="control-sidebar control-sidebar-dark">
                </aside>

            </div>


        );
    }
}


export default withRouter(login);
